<template>
  <div class="publicTransfer">
    <el-card shadow="always">
      <el-form
        ref="formInline"
        size="small"
        label-width="116px"
        :model="formInline"
        inline
      >
        <el-form-item prop="skuName" label="班级名称">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.skuName"
            placeholder="请输入班级名称"
          ></el-input>
        </el-form-item>
        <el-form-item prop="orderNumber" label="订单号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.orderNumber"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="auditStatus" label="审核状态">
          <el-select
            style="width: 290px"
            v-model="formInline.auditStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="审核中" value="1"></el-option>
            <el-option label="通过" value="2"></el-option>
            <el-option label="驳回" value="3"></el-option>
            <el-option label="不需要审核" value="4"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="name" label="用户姓名">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.name"
            placeholder="请输入用户姓名"
          ></el-input>
        </el-form-item>
        <el-form-item prop="payStatus" label="支付状态">
          <el-select
            style="width: 290px"
            v-model="formInline.payStatus"
            placeholder="请选择"
          >
            <el-option label="全部" value=""></el-option>
            <el-option label="未支付" value="1"></el-option>
            <el-option label="已支付" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderState" label="订单状态">
          <el-select
            style="width: 290px"
            v-model="formInline.orderState"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="待支付" value="1"></el-option>
            <el-option label="待签约" value="2"></el-option>
            <el-option label="待评价" value="3"></el-option>
            <el-option label="订单完成" value="4"></el-option>
            <el-option label="订单关闭" value="5"></el-option>
            <el-option label="订单取消" value="6"></el-option>
            <el-option label="已退款" value="7"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="phone" label="用户手机号">
          <el-input
            clearable
            style="width: 290px"
            v-model.trim="formInline.phone"
            placeholder="请输入用户手机号"
          ></el-input>
        </el-form-item>
        <el-form-item prop="createTime" label="创建时间">
          <my-datePicker
            width="290px"
            :scopeDate="formInline.createTime"
            @receiveMyDate="createTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="payType" label="支付方式">
          <el-select
            style="width: 290px"
            v-model="formInline.payType"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="易票联" value="YPL"></el-option>
            <el-option label="微信" value="WX"></el-option>
            <el-option label="支付宝" value="ZFB"></el-option>
            <el-option label="苹果" value="APPLE"></el-option>
            <el-option label="对公转账" value="DGZZ"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderSource" label="订单类别">
          <el-select
            style="width: 290px"
            v-model="formInline.orderSource"
            placeholder="请选择"
          >
            <el-option label="全部" value="-1"></el-option>
            <el-option label="普通订单" value="1"></el-option>
            <el-option label="团购订单" value="2"></el-option>
            <el-option label="内训订单" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="payTime" label="支付时间">
          <my-datePicker
            width="290px"
            :scopeDate="formInline.payTime"
            @receiveMyDate="payTimeReceiveMyDate"
          />
        </el-form-item>
        <el-form-item prop="companyId" label="所属租户">
          <el-select
            style="width: 290px"
            v-model="formInline.companyId"
            placeholder="请选择"
          >
            <el-option v-if="checkAdmin()" label="全部" value="-1"></el-option>
            <el-option
              v-for="item in companyData"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item style="margin-left: 50px">
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button @click="handleReset" style="margin-left: 8px">重置</el-button>
          <el-button style="margin-left: 8px" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 10px" shadow="always">
      <el-radio-group v-model="formInline.auditStatus" v-if="$myStore.state.user.userIdentity === 0" size="small" @input="handleSearch">
        <el-radio-button label="-1">全部</el-radio-button>
        <el-radio-button :label="30">教务审核中</el-radio-button>
        <el-radio-button :label="40">教务审核驳回</el-radio-button>
        <el-radio-button :label="50">财务审核中</el-radio-button>
        <el-radio-button :label="60">财务审核驳回</el-radio-button>
        <el-radio-button :label="70">项目负责人审核中</el-radio-button>
        <el-radio-button :label="80">项目负责人审核驳回</el-radio-button>
      </el-radio-group>
      <el-table border v-loading="loading" :data="data" style="width: 100%;margin-top: 10px">
        <el-table-column label="班级名称" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.skuName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单号" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.orderNumber || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="所属租户" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.companyName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单类别" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.orderSource === 1">普通订单</el-tag>
            <el-tag type="success" v-else-if="row.orderSource === 2">团购订单</el-tag>
            <el-tag type="success" v-else-if="row.orderSource === 3">内训订单</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="提交订单人" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertByName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户昵称" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.nickname || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="学员姓名" minWidth="170" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.name || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="证件号码" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.idCard || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="手机号" minWidth="160" align="center">
          <template slot-scope="{ row, $index }">
            <el-button type="text" @click="handleViewPhone(row, $index)">{{ row.phone || '--' }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="支付类型" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.payType === 'YPL'">易票联</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.payStatus === 1">未支付</el-tag>
            <el-tag v-else-if="row.payStatus === 2" type="success">已支付</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.orderState === 1">待支付</el-tag>
            <el-tag v-else-if="row.orderState === 2" type="success">待签约</el-tag>
            <el-tag v-else-if="row.orderState === 3">待评价</el-tag>
            <el-tag v-else-if="row.orderState === 4" type="warning">订单完成</el-tag>
            <el-tag v-else-if="row.orderState === 5" type="info">订单关闭</el-tag>
            <el-tag v-else-if="row.orderState === 6" type="info">订单取消</el-tag>
            <el-tag v-else-if="row.orderState === 7" type="danger">已退款</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payTime || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" minWidth="180" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.payAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单来源" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.sourceType === 1">PC</el-tag>
            <el-tag v-else-if="row.sourceType === 2" type="success">小程序</el-tag>
            <el-tag v-else-if="row.sourceType === 3" type="info">安卓</el-tag>
            <el-tag v-else-if="row.sourceType === 4" type="danger">ios</el-tag>
            <el-tag v-else-if="row.sourceType === 5" type="warning">H5</el-tag>
            <el-tag v-else-if="row.sourceType === 6" type="warning">后台</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退款状态" minWidth="150" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.refundStatus === 1">未退款</el-tag>
            <el-tag v-else-if="row.refundStatus === 2" type="info">退款中</el-tag>
            <el-tag v-else-if="row.refundStatus === 3" type="success">已退款</el-tag>
            <el-tag v-else-if="row.refundStatus === 4" type="danger">打款失败</el-tag>
            <el-tag v-else-if="row.refundStatus === 5" type="warning">已驳回</el-tag>
            <el-tag v-else-if="row.refundStatus === 6" type="info">已取消退费</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="退款金额" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.refundAmt || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="是否签约" minWidth="140" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.signType === 1">未签约</el-tag>
            <el-tag v-else-if="row.signType === 2" type="success">签约</el-tag>
            <el-tag v-else-if="row.signType === 3" type="info">没有合同</el-tag>
            <el-tag v-else-if="row.signType === 4" type="danger">协议签约中</el-tag>
            <el-tag v-else-if="row.signType === 5" type="warning">暂不用签约</el-tag>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.insertDate || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" minWidth="160" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.auditStatus === 1">审核中</el-tag>
            <el-tag v-else-if="row.auditStatus === 2" type="success">审核通过</el-tag>
            <span
              v-else-if="row.auditStatus === 3"
              class="blue_Box"
              @click="openPublicTransferDetails('reason', row)"
            >查看驳回原因</span>
            <el-tag v-else-if="row.auditStatus === 9" type="warning">不需要审核</el-tag>
            <el-tag v-else-if="row.auditStatus === 30">教务审核中</el-tag>
            <span
              v-else-if="row.auditStatus === 40"
              class="blue_Box"
              @click="openPublicTransferDetails('reason', row)"
            >教务审核驳回</span>
            <el-tag v-else-if="row.auditStatus === 50">财务审核中</el-tag>
            <span
              v-else-if="row.auditStatus === 60"
              class="blue_Box"
              @click="openPublicTransferDetails('reason', row)"
            >财务审核驳回</span>
            <el-tag v-else-if="row.auditStatus === 70">项目负责人审核中</el-tag>
            <span
              v-else-if="row.auditStatus === 80"
              class="blue_Box"
              @click="openPublicTransferDetails('reason', row)"
            >项目负责人审核驳回</span>
            <span v-else>--</span>
          </template>
        </el-table-column>
        <el-table-column label="审核人" minWidth="190" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.auditorName || "--" }}</span>
          </template>
        </el-table-column>
        <el-table-column width="200" fixed="right" align="center" label="操作">
          <template slot-scope="{ row }">
            <span
              v-if="[1,30,50,70].includes(row.auditStatus)"
              class="blue_Box"
              @click="openPublicTransferAudit(row)"
            >审核</span>
            <span
              class="blue_Box"
              v-else-if="[2,3,40,60,80].includes(row.auditStatus)"
              @click="openPublicTransferDetails('details', row)"
            >审核详情</span>
            <span
              v-if="[3,40,60,80].includes(row.auditStatus)"
              class="blue_Box"
              @click="openUploadCertificate(row)"
            >重新上传凭证</span>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <my-pagination
        :page-info="pageInfo"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      />
    </el-card>

    <!-- 审核 -->
    <PublicTransferAudit ref="publicTransferAuditRef" />
    <!-- 审核详情 -->
    <PublicTransferDetails ref="publicTransferDetailsRef" @refresh="refresh" />
    <!-- 审核详情 - 内训报名订单 -->
    <InternalTransferDetails ref="internalTransferDetailsRef" @refresh="refresh" />
    <!-- 上传凭证 -->
    <UploadCertificate ref="uploadCertificateRef" />
    <!-- 导出 -->
    <FileExport ref="FileExport" />
  </div>
</template>

<script>
import FileExport from "@/components/FileExport.vue";
import {
  getOrderListPage,
  getSelectCompanyList,
} from "@/api/orderAdmin/orderList";
import { getAppUserInfo } from "@/api/common";
import myPagination from "@/components/myPagination.vue";
import myDatePicker from "@/components/myDatePicker.vue";
import UploadCertificate from "@/views/orderAdmin/components/uploadCertificate.vue";
import PublicTransferDetails from "@/views/orderAdmin/components/publicTransferDetails.vue";
import InternalTransferDetails from "@/views/orderAdmin/components/internalTransferDetails.vue";
import PublicTransferAudit from "@/views/orderAdmin/components/publicTransferAudit.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "PublicTransfer",
  components: {
    myPagination,
    myDatePicker,
    PublicTransferAudit,
    PublicTransferDetails,
    InternalTransferDetails,
    UploadCertificate,
    FileExport,
  },
  data() {
    return {
      loading: false,
      formInline: {
        skuName: "",
        orderNumber: "",
        payStatus: "",
        auditStatus: "-1",
        orderSource: "-1",
        orderState: "-1",
        createTime: [],
        createStartTime: "",
        createEndTime: "",
        payTime: [],
        payStartTime: "",
        payEndTime: "",
        name: "",
        phone: "",
        tradeNo: "",
        payType: "-1",
        companyId: "",
        auditStatus: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      companyData: [],
    };
  },
  mounted() {
    this.getSelectCompanyList();
  },
  methods: {
    // 手机号
    phoneRE(payload) {
      if (!payload) return "--";
      return payload.replace(/(\d{3})\d*(\d{4})/, "$1****$2");
    },
    // 导出
    handleExport() {
      this.$refs.FileExport.init(
        { ...this.searchData, payType: "DGZZ" }, // 搜索表单参数
        "jsw-order-provider", // 后端对应业务线服务
        "/order/adm/order/testDown", // 导出-对应的接口
        1, //  状态：0get、1post
        "订单统计.xlsx" //文件名称
      );
    },
    // 租户列表
    getSelectCompanyList() {
      getSelectCompanyList().then((res) => {
        if (res.code === 0) {
          this.companyData = res.data || [];
          this.formInline.companyId = res.data[0]?.id;
          this.searchData.companyId = res.data[0]?.id;
          this.getOrderListPage({
            page: 1,
            limit: 10,
            companyId: this.formInline.companyId,
          });
        }
      });
    },
    // 重新上传凭证
    openUploadCertificate(payload) {
      this.$refs.uploadCertificateRef.init(payload);
    },
    // 审核详情
    openPublicTransferDetails(status, payload) {
      if (payload.orderSource === 3) {
        this.$refs.internalTransferDetailsRef.init(payload);
      } else {
        this.$refs.publicTransferDetailsRef.init(status, payload);
      }
    },
    // 审核
    openPublicTransferAudit(payload) {
      if (payload.orderSource === 3) {
        this.$refs.internalTransferDetailsRef.init(payload);
      } else {
        this.$refs.publicTransferAuditRef.init(payload);
      }
    },
    // 刷新
    refresh() {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 列表请求
    async getOrderListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      delete payload.payTime;
      const res = await getOrderListPage({ ...payload, payType: "DGZZ" });
      this.data = res.data?.records || [];
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 创建时间
    createTimeReceiveMyDate(payload) {
      this.formInline.createTime = payload;
      this.formInline.createStartTime = payload[0] + " 00:00:00";
      this.formInline.createEndTime = payload[1] + " 23:59:59";
    },
    // 支付时间
    payTimeReceiveMyDate(payload) {
      this.formInline.payTime = payload;
      this.formInline.payStartTime = payload[0] + " 00:00:00";
      this.formInline.payEndTime = payload[1] + " 23:59:59";
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getOrderListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.formInline.payTime = [];
      this.formInline.payStartTime = "";
      this.formInline.payEndTime = "";
      this.$refs["formInline"].resetFields();
      this.getSelectCompanyList();
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getOrderListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
    handleViewPhone (row, index) {
      if (!/\*/.test(row.phone)) {
        return
      }
      getAppUserInfo({ userId: row.userId }).then(({ code, data: { phone } }) => {
        if (code === 0) {
          this.data.forEach((item, i) => {
            if (i === index) {
              item.phone = phone
            }
          })
        }
      })
    }
  },
};
</script>

<style lang="scss" scoped>
.publicTransfer {
  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }
}
</style>
